module.exports = __webpack_public_path__ + "img/xxzanwu.049fcf5d.png";